import { render, staticRenderFns } from "./special-requests.vue?vue&type=template&id=6fdae348&scoped=true"
import script from "./special-requests.vue?vue&type=script&lang=js"
export * from "./special-requests.vue?vue&type=script&lang=js"
import style0 from "./special-requests.vue?vue&type=style&index=0&id=6fdae348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdae348",
  null
  
)

export default component.exports